const s = "Azione scaduta. Si prega di controllare la propria connessione internet e riprovare.", e = { 400: "Questo indirizzo email non è registrato su $t(_company). Si prega di assicurarsi che sia corretto o di registrarsi qui sotto.", 404: "$t(responses.login.400)", 500: "$t(responses.default)" }, o = { 400: "$t(responses.default)", 500: "$t(responses.default)" }, r = { 2033: "Sessione creata con successo.", 2064: "Sessione aggiornata con successo." }, a = { 200: "Creata con successo la tua prima sessione.", 201: "$t(responses.dashboardSession.200)" }, i = { 2084: "La richiesta di accesso alla sessione era già in stato approvato", 2088: "Hai già richiesto l'accesso a questa sessione.", email: { 200: "Persone aggiunte" }, domain: { 200: "Gruppo aggiunto" } }, t = { 200: "Ottimo! Ti terremo aggiornato." }, n = { 404: "$t(responses.default)", 405: "Il codice di verifica non è corretto. Per favore, ricontrolla.", 500: "$t(responses.default)" }, c = { 500: "Mi dispiace, si è verificato un errore. Per favore, riprova.", avatar: { 400: "Errore nel salvataggio dell'avatar. Per favore, riprova." } }, l = {
  default: "Mi dispiace, si è verificato un errore. Per favore, riprova.",
  timeout: s,
  login: e,
  register: o,
  session: r,
  dashboardSession: a,
  sessionAccess: i,
  subscribe: t,
  verify: n,
  user: c
};
export {
  a as dashboardSession,
  l as default,
  e as login,
  o as register,
  r as session,
  i as sessionAccess,
  t as subscribe,
  s as timeout,
  c as user,
  n as verify
};
